import { createUseStyles } from 'react-jss'

import { COLOR, MQ, Z_INDEX, TYPOGRAPHY } from 'utils/constants'

export const useStyles = createUseStyles({
  wrapper: {
    ...TYPOGRAPHY.PROXIMA_NOVA,
    fontSize: 18,
    lineHeight: 1.1,
    fontWeight: 400,
    letterSpacing: '0.05em',
    width: '75%',
    margin: 'auto',
    padding: [75, 0],
    [MQ.TABLET]: {
      fontSize: 14,
      width: '62%',
      padding: [85, 0],
    },
    [MQ.DESKTOP]: {
      fontSize: 24,
      padding: [125, 0],
    },
  },
  links: {
    color: COLOR.LIGHT_GREEN,
    textDecoration: 'underline',
  },
  underline: {
    textDecoration: 'underline',
  },
  bold: {
    fontWeight: '700 !important',
  },
  italic: {
    fontStyle: 'italic !important',
  },
  articleText: {
    position: 'relative',
    zIndex: Z_INDEX.CONTENT,
    [MQ.TABLET]: {
      margin: 'auto',
    },
    [MQ.TABLET_LARGE]: {},
  },

  flashText: {
    textAlign: 'center',
    margin: 0,
    padding: [12, 0],
    display: 'flex',
    justifyContent: 'center',
    width: '90%',
    [MQ.TABLET]: {
      padding: [16, 0],
    },
    [MQ.TABLET_LARGE]: {
      width: '100%',
    },
  },
  flashLinks: {
    color: COLOR.WHITE,
    fontWeight: 500,
  },
  flashWrapper: {
    marginLeft: 'auto',
    [MQ.TABLET_LARGE]: {},
    [MQ.LAPTOP]: {},
    [MQ.LAPTOP_LARGE]: {},
  },
  title: {
    textAlign: 'center',
    marginBottom: 35,
    [MQ.TABLET]: {
      marginBottom: 40,
    },
    [MQ.DESKTOP]: {
      marginBottom: 55,
    },
  },
})
